import { ISystemSettingsApiCall, IRestApiService, SystemSetting } from '../types';

class SystemSettingsApiCall implements ISystemSettingsApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  getByName<T = any>(name: string): Promise<SystemSetting<T>> {
    return this.restApiService.get<SystemSetting<T>>(`system-settings/${name}`);
  }
}

export default SystemSettingsApiCall;
